import { cn } from '@/lib/utils';
import type { ApiError } from '@portfolio-manager/sdk';

const formatErrorMessage = (error: ApiError): string => {
  return error.message;
};

export interface ApiErrorMessageProps {
  error: ApiError | null;
  className?: string;
}

export function ApiErrorMessage({ error, className }: ApiErrorMessageProps): React.ReactElement | null {
  if (error === null) {
    return null;
  }
  return (
    <p
      role="alert"
      className={cn(
        'text-sm text-center text-destructive border-destructive/20 border-x-3 rounded-sm px-2 m-3',
        className,
      )}
    >
      {formatErrorMessage(error)}
    </p>
  );
}
